import getBannerRow from "../DataDisplayRow/BannerRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class BannerTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getBannerRow()
    }
}

let bannerTable: BannerTable | null = null;

export default function getBannerTable(): BannerTable {
    if (bannerTable === null)
        bannerTable = new BannerTable()
    return bannerTable
}